<div class="template" [ngClass]="{ 'dark-mode': darkMode }">
  <div *ngIf="!error && configuration" class="image-url">
    <div class="container">
      <div class="value-propositions" *ngIf="configuration.valuePropositions">
        <div *ngFor="let proposition of configuration.valuePropositions; let isLast = last"
             class="value-proposition">

          <div class="vp-top-row">
            <div *ngIf="hasVpIcons && proposition.iconUrl" class="vp-icon">
              <img class="vp-icon-asset" [src]="darkMode && proposition.darkIconUrl ? proposition.darkIconUrl : proposition.iconUrl" alt="" />
            </div>
            <div class="vp-text">
              <div class="vp-title">{{ proposition.title }}</div>
              <div class="vp-description">{{ proposition.description }}</div>
            </div>
          </div>

          <img class="asset" [src]="proposition.assetUrl" alt="" />

          <div class="spacer" *ngIf="!isLast" style="height: 1px; background-color: #E0E3E6;"></div>
        </div>
      </div>
    </div>
  </div>
</div>
